// import HomeContaainer from "./HomeContainer";
// export default HomeContaainer;


import React,{useState, useEffect} from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Section from "../../components/Section";
import Popular from "../../components/Popular";
import Loader from "components/Loader";
import Poster from "../../components/Poster";
import PosterP from "../../components/PosterP";
import {gsap} from "gsap";
import defaultAxios from "axios";
import Helmet from "react-helmet";

const Container = styled.div`
    padding: 100px 50px 0 50px;
    margin-bottom: 50px;
    overflow: hidden;
    
`;
// fixing..
const useAxios = (opt, axiosInstance = defaultAxios) => {
    const [state, setState] = useState({
      loading: true,
      data: []
    });

    useEffect(() => {
        axiosInstance(opt)
        .then((data) => {
            setTimeout(() => {

                setState({
                    ...state,
                    loading: false,
                    data,
                });
            }, 1300)
           
        }).catch((error) => {
            setState({
                ...state,
                loading: false,
                error
            })
        })
    },[]);

    return {...state};
}

// fixing..
const HomePresenter = () => 
{
    const baseURL = "https://api.themoviedb.org/3";
    const {loading, data: nowPlaying} = useAxios({
      url: `${baseURL}/movie/now_playing`,
      params: {
        api_key: "d15e68bc9579ae54154a1100009fe8df",
        language: "en-US"
    }
    });
        //upComming
    const {loading: loadingUpcomming, data: upComming} = useAxios({
        url : `${baseURL}/movie/upcoming`,
        params: {
            api_key: "d15e68bc9579ae54154a1100009fe8df",
            language: "en-US"
        }
    });
        // //Popular
    const {loading: loadingPopular, data: popular} = useAxios({
        url: `${baseURL}/movie/popular`,
        params: {
            api_key: "d15e68bc9579ae54154a1100009fe8df",
            language: "en-US"
        }
    });
        
     
        return <>
        {loading || loadingUpcomming || loadingPopular ? (
            <>
          <Loader />
          <Helmet>
                <title>loading...</title>
            </Helmet>
            </>
        ) : 
        <Container >
            <Helmet>
                <title>Movies | DainFlix</title>
            </Helmet>
          {popular.data.results && popular.data.results.length > 0 && <Popular title="Pouplar Movies">{popular.data.results.map((movie, index) => <PosterP key={index} id={movie.id} title={movie.original_title} imageUrl={movie.poster_path} year={movie.release_date && movie.release_date.substring(0,4)} rating={movie.vote_average} isMovie={true} />)}</Popular> }
          {nowPlaying.data.results && nowPlaying.data.results.length > 0 && <Section title="Now Playing">{nowPlaying.data.results.map((movie, index) => <Poster key={index} id={movie.id} title={movie.original_title} imageUrl={movie.poster_path} year={movie.release_date && movie.release_date.substring(0,4)} rating={movie.vote_average} isMovie={true} />)}</Section> }
          {upComming.data.results && upComming.data.results.length > 0 && <Section title="Upcomming Movies">{upComming.data.results.map((movie, index) => <Poster key={index} id={movie.id} title={movie.original_title} imageUrl={movie.poster_path} year={movie.release_date && movie.release_date.substring(0,4)} rating={movie.vote_average} isMovie={true} />)}</Section> }     
        </Container>}
  </>
       
        }


//dd
// const HomePresenter = ({nowPlaying, upComming, popular, error, loading}) => 
//         {
        
//         return (
//         loading ? <Loader />  :
//         <Container >
//             {popular && popular.length > 0 && <Popular title="Pouplar Movies">{popular.map((movie, index) => <PosterP key={index} id={movie.id} title={movie.original_title} imageUrl={movie.poster_path} year={movie.release_date && movie.release_date.substring(0,4)} rating={movie.vote_average} isMovie={true} />)}</Popular> }
//             {nowPlaying && nowPlaying.length > 0 && <Section title="Now Playing">{nowPlaying.map((movie, index) => <Poster key={index} id={movie.id} title={movie.original_title} imageUrl={movie.poster_path} year={movie.release_date && movie.release_date.substring(0,4)} rating={movie.vote_average} isMovie={true} />)}</Section> }
//             {upComming && upComming.length > 0 && <Section title="Upcomming Movies">{upComming.map((movie, index) => <Poster key={index} id={movie.id} title={movie.original_title} imageUrl={movie.poster_path} year={movie.release_date && movie.release_date.substring(0,4)} rating={movie.vote_average} isMovie={true} />)}</Section> }
            
//         </Container>
//             )
//         }
 

HomePresenter.prototype = {
    nowPlaying: PropTypes.array,
    upComming: PropTypes.array,
    popular: PropTypes.array,
    error: PropTypes.bool.isRequired,
    loading: PropTypes.string
}


export default HomePresenter;